import { all, call } from "redux-saga/effects";
import onVerifyTransaction from "./verifyTransaction";
import onGetTransactions from "./getTransactions";

export default function* transactionsSagas() {
  yield all([call(onVerifyTransaction), call(onGetTransactions)]);
}
